webpackJsonp([185433363909976],{

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/assets/less/main.less'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default LESS file.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For new projects, this imports the styles from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '../css/main.css'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Defaults'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default file included in new projects looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'css', text: '\n      @import "../css/main.css";\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-assets-less-main-js-c3d61790b54a89824147.js